import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FALLBACK_MESSAGE_CLASS_NAME = 'FallbackMessage';
export const FALLBACK_MESSAGE_CLASS_SLOTS = [
	'root',
	'children',
	'header',
	'icon',
	'body',
	'text',
] as const;

export type FallbackMessageClassSlot =
	(typeof FALLBACK_MESSAGE_CLASS_SLOTS)[number];

export interface FallbackMessageClasses {
	/** styles applied to the root element */
	root: string;
	children: string;
	header: string;
	body: string;
	icon: string;
	text: string;

	// severities
	// TODO: rename to color
	severityError: string;
	severityInfo: string;
	severitySuccess: string;
	severityWarning: string;
	severityPrimary: string;
	severitySecondary: string;

	// variants
	light: string;
}

export type FallbackMessageClassKey = keyof FallbackMessageClasses;

export const getFallbackMessageUtilityClass = (slot: string) =>
	generateUtilityClass(FALLBACK_MESSAGE_CLASS_NAME, slot);

export const fallbackMessageClasses: FallbackMessageClasses =
	generateUtilityClasses(FALLBACK_MESSAGE_CLASS_NAME, [
		'root',
		'body',
		'children',
		'header',
		'icon',
		'text',
		'light',
		'severityError',
		'severityInfo',
		'severitySuccess',
		'severityWarning',
		'severityPrimary',
		'severitySecondary',
	]);

export default fallbackMessageClasses;
